<template>
  <el-checkbox-group v-model="checkList" @change="change" class="sr-check-box">
    <el-checkbox
      v-for="op in list"
      :disabled="op.disabled || false"
      :label="item.label ? op[item.label] : op.dataValue"
      :name="op.dataValue"
      :key="op.dataValue"
      >{{ op.dataName }}</el-checkbox
    >
  </el-checkbox-group>
</template>

<!--
  功能：下拉框组件
  汪振涛
  时间：2020年11月19日 17:09:02
  版本：v1.0
-->
<script>
export default {
  name: "SrCheckbox",
  model: {
    prop: "value",
    event: "change",
  },

  props: {
    value: Array,
    item: {
      type: Object,
      default: {},
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    value: {
      handler(val) {
        this.checkList = val;
      },
      deep: true,
    },
  },
  data() {
    return {
      checkList: this.value,
    };
  },
  methods: {
    change(value) {
      this.$emit("change", value);
    },
  },
};
</script>

<style scoped >
</style>



// WEBPACK FOOTER //
// packages/SrCheckbox/SrCheckbox.vue